const startDownload = (url) => window.location.assign(url);

export default startDownload;
